import { Redirect, Route, Switch } from 'react-router-dom';

import NotFound from 'pages/NotFound/NotFound';
import { OrganizationsPage } from 'pages/Organizations';
import { UsersPage } from 'pages/Users';
import { UserDiagnosticsPage } from 'pages/UserDiagnostics';

export const DefaultRoutes = {
  OrganizationsPage: '/',
  UsersPage: '/users',
  UserDiagnosticsPage: '/issue-reports',
} as const;

export const routes = (
  <Switch>
    <Route exact path={`${DefaultRoutes.OrganizationsPage}`} component={OrganizationsPage} />
    <Route exact path={`${DefaultRoutes.UsersPage}/:organizationId`} component={UsersPage} />
    <Route exact path={`${DefaultRoutes.UserDiagnosticsPage}`} component={UserDiagnosticsPage} />
    <Redirect exact from={'/organization_reassigned'} to={DefaultRoutes.OrganizationsPage} />
    <Route component={NotFound} />
  </Switch>
);
